import { SunDiya, Sparkle } from "@/components/art/Poster";
import { useCourtyard } from "@/context/CourtyardContext";
import { scrollToId } from "@/lib/event";
import { Reveal } from "@/components/invite/Reveal";
import PassStudio from "@/components/invite/PassStudio";

const STATUS = { yes: "You’re coming", maybe: "You’re a maybe", no: "You can’t make it" };

export default function RsvpBand() {
  const { rsvp, openRsvp } = useCourtyard();
  return (
    <section id="rsvp" className="bg-yellow-print relative scroll-mt-16 overflow-hidden border-y-[2.5px] border-[var(--navy)] py-20 lg:py-28" aria-labelledby="rsvp-title">
      <div className="rays-soft pointer-events-none absolute inset-0" aria-hidden="true" />
      <div className="pointer-events-none absolute -right-10 -top-10 w-44 opacity-90 sm:w-60" aria-hidden="true"><SunDiya lit /></div>
      <Sparkle className="absolute bottom-10 left-8 w-9" color="#D81B60" />
      <Reveal className="relative mx-auto max-w-3xl px-5 text-center sm:px-8">
        <p className="eyebrow">RSVP</p>
        <h2 id="rsvp-title" className="font-poster mt-3 text-[clamp(3rem,13vw,6.5rem)] leading-[0.9]">
          Aa rahe ho <span className="font-serif-i text-[var(--pink-deep)]">na?</span>
        </h2>
        {rsvp ? (
          <div className="mt-8" data-testid="rsvp-status">
            <p className="text-lg font-medium">
              {STATUS[rsvp.response]}, <span className="font-extrabold [overflow-wrap:anywhere]">{rsvp.name}</span>
              {rsvp.response !== "no" && ` · ${rsvp.party_size} ${rsvp.party_size === 1 ? "person" : "people"}`}.
            </p>
            <div className="mt-6 flex flex-col justify-center gap-4 sm:flex-row">
              <button type="button" className="btn-pink" onClick={openRsvp} data-testid="rsvp-edit-button">Edit my RSVP</button>
              <button type="button" className="btn-ghost" onClick={() => scrollToId("my-pass")} data-testid="rsvp-see-pass-button">See my pass</button>
            </div>
          </div>
        ) : (
          <>
            <p className="font-serif-i mx-auto mt-4 max-w-xl text-2xl">Takes thirty seconds. Less time than “bas nikal rahe hain”.</p>
            <button type="button" className="btn-pink mt-8 min-h-[58px] px-10 text-lg" onClick={openRsvp} data-testid="rsvp-band-button">RSVP now</button>
          </>
        )}
      </Reveal>
      <PassStudio />
    </section>
  );
}
